import { BaseBlock } from "../BaseBlock";

export class ChangeSubscriptionInfoBlock
    extends BaseBlock {

    public override mount(): void {

        super.mount();

        const root =
            document.createElement("section");

        root.className =
            "change-subscription-info";

        const title =
            document.createElement("h3");

        title.className =
            "change-subscription-info-title";

        title.textContent =
            "Що відбудеться після підтвердження";

        root.appendChild(title);

        const list =
            document.createElement("ul");

        list.className =
            "change-subscription-info-list";

        [

            "Буде оформлено нову підписку.",

            "Після успішної оплати автоматичне продовження поточної підписки буде вимкнено.",

            "Доступ до поточної підписки збережеться до завершення вже оплаченого періоду."

        ].forEach(text => {

            const item =
                document.createElement("li");

            item.textContent = text;

            list.appendChild(item);

        });

        root.appendChild(list);

        this.root = root;

    }

}